import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import "./style/achievement.css";

const achievement = props => {
	const { date, title, description, link, linkText } = props;

	return (
		<div className="achievement">
			<div className="achievement-left-side">
				<div className="achievement-date">{date}</div>
			</div>

			<Link to={link}>
				<div className="achievement-right-side">
					<div className="achievement-title">{title}</div>
					<div className="achievement-description">{description}</div>
					<div className="achievement-link">
						{linkText}
						<FontAwesomeIcon
							style={{ fontSize: "10px" }}
							icon={faChevronRight}
						/>
					</div>
				</div>
			</Link>
		</div>
	);
};

export default achievement;
